import CoursePage from './CoursePage';
import useEvents from '../../hooks/useEvents';

export default function TCEEventsPage() {
  const { events, loading } = useEvents('tceevent');
  return (
    <CoursePage courses={events} loading={loading} pageTitle={'TCE-Events'} category={'tceevent'} />
  );
}
